var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPrinter = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_x32_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    width: "16px",
    height: "19px",
    fill: "#000000",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, " .st0{fill:#000000;} "), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 161.187,
    y: 276.144,
    className: "st0",
    width: 189.626,
    height: 18.968
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144.591,
    y: 333.04,
    className: "st0",
    width: 222.818,
    height: 18.959
  }), /*#__PURE__*/React.createElement("rect", {
    x: 137.484,
    y: 387.562,
    className: "st0",
    width: 175.402,
    height: 18.959
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M438.328,93.436h-35.365V34.368H109.037v59.068H73.672C32.992,93.436,0,126.428,0,167.108v89.887 c0,40.672,32.992,73.672,73.672,73.672h5.064l-20.31,100.571c-0.51,2.536-0.762,5.107-0.762,7.661 c0,8.856,3.038,17.539,8.752,24.526c7.358,8.995,18.361,14.207,29.98,14.207h193.582c28.162,0,51.363-1.802,70.668-5.411 c14.484-2.718,26.802-6.458,37.329-11.367c15.774-7.298,27.539-17.496,35.312-29.85c7.818-12.328,11.626-26.31,13.419-41.139 l0.234-1.965l-0.416-1.931l-11.886-55.302h3.688c40.68,0,73.672-33,73.672-73.672v-89.887 C512,126.428,479.008,93.436,438.328,93.436z M132.74,58.071H379.26v35.365H132.74V58.071z M379.944,174.216 c0,9.548-7.73,17.28-17.28,17.28c-9.54,0-17.271-7.731-17.271-17.28c0-9.54,7.731-17.27,17.271-17.27 C372.214,156.945,379.944,164.675,379.944,174.216z M414.962,415.464c-3.22,5.843-7.35,10.882-13.08,15.462 c-8.58,6.839-21.063,12.648-39.312,16.717c-11.402,2.528-25.011,4.362-41.069,5.367c5.288-5.108,11.063-11.055,17.192-17.886 c12.51-13.972,26.257-31.373,39.182-51.423c14.207,4.553,25.643,9.973,33.755,14.431c3.385,1.862,6.164,3.54,8.346,4.943 C418.659,407.578,417.014,411.724,414.962,415.464z M376.308,363.418l-6.874-1.948l-3.766,6.087 c-16.787,27.14-35.65,49.752-50.904,65.422c-7.619,7.826-14.353,13.92-19.323,17.903c-1.54,1.238-2.883,2.242-4.016,3.03 c-0.494,0.009-0.944,0.017-1.446,0.017H96.397c-4.511,0-8.778-2.026-11.635-5.506c-2.216-2.718-3.394-6.086-3.394-9.523 c0-0.986,0.095-1.982,0.294-2.978l39.442-195.331h269.913l30.386,141.276C410.98,376.083,395.709,368.906,376.308,363.418z M423.091,191.495c-9.54,0-17.271-7.731-17.271-17.28c0-9.54,7.731-17.27,17.271-17.27c9.549,0,17.28,7.73,17.28,17.27 C440.371,183.764,432.64,191.495,423.091,191.495z"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPrinter);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/printer.454e2516560134a1997c9dd8ed6b0b94.svg";